/**
 * StationHistoryPanel component - displays station movement history
 */
import { fmtDec } from "../../utils";

export default function StationHistoryPanel({
  selectedStation,
  stationHistory,
  onClose,
  produit,
}) {
  const prodLabel = produit === "essence" ? "Super" : "Go";

  // Don't show until history has loaded at least once
  if (!stationHistory) return null;

  return (
    <div style={{ marginTop: 32 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <h2 style={{ margin: 0, color: "var(--text)" }}>
          {selectedStation
            ? `${selectedStation.label} - ${prodLabel}`
            : `Toutes les stations - ${prodLabel}`}
        </h2>
        {selectedStation && (
          <button
            onClick={onClose}
            style={{
              background: "var(--bg-elevated)",
              border: "1px solid var(--border)",
              padding: "8px 16px",
              borderRadius: 6,
              cursor: "pointer",
              color: "var(--text)",
              fontSize: 13,
            }}
          >
            ✕ Fermer
          </button>
        )}
      </div>

      {stationHistory.loading ? (
        <div
          style={{
            textAlign: "center",
            padding: 40,
            color: "var(--muted)",
          }}
        >
          Chargement...
        </div>
      ) : (
        <>
          {/* Combined Movements Section */}
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 12,
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: 14,
                  color: "var(--text)",
                }}
              >
                📊 Historique
              </h3>
              <span
                style={{
                  background: "var(--blue)",
                  color: "#fff",
                  padding: "2px 8px",
                  borderRadius: 12,
                  fontSize: 11,
                  fontWeight: 600,
                }}
              >
                {stationHistory.movements.length} entrées
              </span>
            </div>
            {stationHistory.movements.length === 0 ? (
              <div
                style={{
                  color: "var(--muted)",
                  fontStyle: "italic",
                  padding: 20,
                }}
              >
                Aucun mouvement
              </div>
            ) : (
              <div className="card" style={{ padding: 0 }}>
                {stationHistory.movements.map((mov, idx) => {
                  const isLivraison = mov.type === "livraison";
                  return (
                    <div key={idx} className="log-item">
                      <div className="log-icon">
                        {isLivraison ? "🚛" : "⛽"}
                      </div>
                      <div className="log-body">
                        <div className="log-desc">
                          <strong>{isLivraison ? "Livraison" : "Vente"}</strong>{" "}
                          {!selectedStation && mov.station && (
                            <span
                              style={{
                                color: "var(--blue)",
                                fontSize: 11,
                                marginLeft: 4,
                              }}
                            >
                              ({mov.station})
                            </span>
                          )}
                          {isLivraison
                            ? `— ${mov.cuve}${
                                mov.numbl ? ` · BL ${mov.numbl}` : ""
                              }`
                            : `— ${prodLabel}`}
                        </div>
                        <div className="log-meta">{mov.date}</div>
                      </div>
                      <div
                        className="log-qty"
                        style={{
                          color: isLivraison ? "var(--green)" : "var(--red)",
                        }}
                      >
                        {isLivraison ? "+" : "-"}
                        {fmtDec(mov.volume, 3)} L
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
